import { websiteUrl } from "../config/config";

export const SuperAdmins =
	websiteUrl === "https://events.konfhub.com"
		? ["hari@konfhub.com", "ganesh@konfhub.com", "rohit@konfhub.com", "srushith@konfhub.com"]
		: [
			"hemanth@konfhub.com",
			"sudha@konfhub.com",
			"amarnadh@konfhub.com",
			"srushti@konfhub.com",
			"qa@konfhub.com",
			"saatwik@konfhub.com",
			"mayank@konfhub.com",
			"hari@konfhub.com",
			"ganesh@konfhub.com",
			"rohit@konfhub.com",
			"srushith@konfhub.com",
			"haripriya@konfhub.com",
			"dipak@konfhub.com"
		];
